import React, { useEffect } from 'react';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { useRouter } from 'next/navigation';

interface Props {
  children: JSX.Element;
}
const AppUrlListener: React.FC<Props> = ({children}) => {
  let router = useRouter();
  useEffect(() => {
    App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
      // Example url: https://beerswift.app/tabs/tab2
      // slug = /tabs/tab2
      const slug = event.url.split('.app').pop();
      if (slug) {
        router.replace(slug);
      }
      // If no match, do nothing - let regular routing
      // logic take over
    });
  }, []);

  return children;
};

export default AppUrlListener;